import React from "react";
import { Link } from "react-router-dom";
import { getFeaturedProjects } from "../data/projects";
import Deco from "./Deco";

const FeaturedWork = () => {
  const featuredProjects = getFeaturedProjects();

  return (
    <section className="featured-work-section" id="featured-work">
      <Deco name="two" className="deco-fw deco-fw--left" />
      <Deco name="seven" className="deco-fw deco-fw--right" />
      <div className="container">
        <div className="featured-work-header">
          <div>
            <h2 className="featured-work-title">Featured Work</h2>
            <p className="featured-work-subtitle">
              A curated set of recent projects, designed to feel premium,
              readable, and consistent across every touchpoint.
            </p>
          </div>
          <Link className="featured-work-all" to="/work">
            View all work
          </Link>
        </div>

        <div className="featured-work-grid">
          {featuredProjects.map((project) => (
            <Link
              key={project.id}
              className="featured-work-card"
              to={`/work?project=${project.id}`}
              aria-label={`View ${project.title} project`}
            >
              <div className="featured-work-card__media">
                <img
                  src={project.thumb}
                  alt={`${project.title} preview`}
                />
              </div>
              <div className="featured-work-card__body">
                <div className="featured-work-card__meta">{project.meta}</div>
                <h3 className="featured-work-card__title">{project.title}</h3>
                <p className="featured-work-card__desc">{project.shortDesc}</p>
                <span className="featured-work-card__cta">View project</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedWork;
